import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { assertNever } from '@which/shared'

import {
  useSubVerticalCrScamsTopicPageQuery,
  useSubVerticalCrTopicPageQuery,
  useSubVerticalReviewsPageQuery,
} from '../../../generated/frontend'
import type { PageParams } from '../../../routes'
import { usePageProps } from '../../../shared/usePageProps'
import { SubVerticalTemplateName } from '../sub-vertical-types'

export const useSubVerticalPageQuery = () => {
  const { firstSectionSlug } = useParams<PageParams>()
  const { template, context } = usePageProps()
  const subVerticalTemplate = template as SubVerticalTemplateName

  const useQuery = useMemo(() => {
    switch (subVerticalTemplate) {
      case 'CR Topic':
        return useSubVerticalCrTopicPageQuery
      case 'CR Scams Topic':
        return useSubVerticalCrScamsTopicPageQuery
      case 'Subvertical':
        return useSubVerticalReviewsPageQuery
      default:
        assertNever(subVerticalTemplate)
    }
  }, [subVerticalTemplate])

  return useQuery({
    variables: { firstSectionSlug, context: context || '' },
  })
}
